import StatisticsManage from './index';
import UserAssetStatistics from './userAssetStatistics';

export default {
    path: '/dataAnalysis',
    component: StatisticsManage,
    children: [
        {path: '/dataAnalysis/user/asset/statistics', component: UserAssetStatistics}
    ]
};
